// Mirrors the current field-spec table for attachment size/extension limits. Bug 157831/157916's
// original fix (PR #2864) mirrored UploadIncidentRecordFileValidator.cs's LargeFileFieldTypeIds
// grouping, which treats Incident Report Attachment and Evidence identically (25MB, pdf/doc/docx
// for both) - that grouping itself is wrong per the actual spec: the two fields have different
// size limits and different (non-overlapping in one direction) extension lists. This is a real
// backend bug too (UploadIncidentRecordFileValidator.cs needs the same split), not just a
// front-end drift - see the write-up handed to the API session.

/** Incident Report Attachment - single upload, follows the same size class as the other
 *  case-document fields (3MB) but with its own extension list (no .doc, unlike CASE_DOCUMENT_*). */
export const INCIDENT_REPORT_ATTACHMENT_MAX_SIZE_BYTES = 3 * 1024 * 1024;
export const INCIDENT_REPORT_ATTACHMENT_ALLOWED_EXTENSIONS = [
  ".jpg",
  ".jpeg",
  ".png",
  ".pdf",
  ".docx",
  ".xls",
  ".xlsx",
];

/** Evidence - multiple uploads, larger size ceiling, and the only field that accepts video. */
export const EVIDENCE_MAX_SIZE_BYTES = 25 * 1024 * 1024;
export const EVIDENCE_ALLOWED_EXTENSIONS = [
  ".jpg",
  ".jpeg",
  ".png",
  ".pdf",
  ".docx",
  ".xls",
  ".xlsx",
  ".mp4",
  ".mov",
  ".avi",
  ".wmv",
  ".mkv",
];

/** Every other case document - NTE/NOH/NODA/Case Summary/AWOL Letter/T-BWL (signed and unsigned),
 *  Resignation, Termination (UploadIncidentRecordFileValidator.cs's CaseDocumentMaxSizeBytes).
 *  Bug 157955: narrowed to PDF/JPG/JPEG/PNG only - the backend's CaseDocumentAllowedExtensions
 *  still permits DOC/DOCX/XLS/XLSX too (per 157826/157829), so this is a client-only tightening,
 *  not a contract change - a server that accepts a wider set than the client offers is safe. */
export const CASE_DOCUMENT_MAX_SIZE_BYTES = 3 * 1024 * 1024;
export const CASE_DOCUMENT_ALLOWED_EXTENSIONS = [".pdf", ".jpg", ".jpeg", ".png"];
